import React from 'react';
import { Spinner } from 'reactstrap';
import './styles.scss';

type OverlayLoadingProps = { isVisible?: boolean };

const OverlayLoading = ({ isVisible }: OverlayLoadingProps) =>
  isVisible && (
    <div className="overlay-loading">
      <Spinner className="overlay-loading__spinner">
        {/* eslint-disable-next-line react/jsx-curly-brace-presence -- must be a literal empty string, not omitted: reactstrap's Spinner defaultProps falls back to children="Loading..." when children is undefined */}
        {''}
      </Spinner>
      <div className="overlay-loading__text">
        <div>Re-Calculating....</div>
        <div>Please wait</div>
      </div>
    </div>
  );

export default OverlayLoading;
